<template>
  <div class="productDetail" v-if="productDetail">
    <Banner
      ref="cBanner"
      :banner_img="resBanners"
      banner_en="PRODUCTION CENTER"
      banner_cn="产品中心"
    ></Banner>
    <div class="mainBody">
      <div class="addrtit marginT60">
        <span>您所在的位置：</span
        ><i>产品中心 > {{ productDetail.product }}产品简介</i>
      </div>
      <div class="maincon marginT30 clear">
        <div class="fl">
          <div class="detailcon">
            <div class="detailcon_tit">
              {{ productDetail.brand }}{{ productDetail.product }}产品简介
            </div>
            <div class="detailcon_main" v-if="productDetail.traits">
              <div class="detailcon_main_tit">性状</div>
              <div class="detailcon_main_p">
                {{ productDetail.traits }}
              </div>
            </div>
            <div class="detailcon_main" v-if="productDetail.use">
              <div class="detailcon_main_tit">用途</div>
              <div class="detailcon_main_p">
                {{ productDetail.use }}
              </div>
            </div>
            <div class="detailcon_main" v-if="productDetail.qualityStandard">
              <div class="detailcon_main_tit">质量标准</div>
              <div class="detailcon_main_p">
                {{ productDetail.qualityStandard }}
              </div>
            </div>
            <div class="detailcon_main" v-if="productDetail.package">
              <div class="detailcon_main_tit">包装</div>
              <div class="detailcon_main_p">{{ productDetail.package }}</div>
            </div>
          </div>
        </div>
        <div class="fl detailimg">
          <div class="detailimgcon">
            <div class="showImgCon">
              <img
                :src="
                  showProductImg
                    ? showProductImg
                    : productDetail.productImg[0].img
                "
              />
            </div>
            <div class="detailImgPagination">
              <swiperCpt
                v-if="productDetail.productImg.length > 0"
                class="detailimgSwiperCpt wow fadeInUp animated"
                ref="indexDetailimgSwiper"
                :slidesPerView="4"
                :delay="5000"
                :loop="false"
                :autoplay="false"
                sid="indexDetailimgSwiper"
              >
                <div
                  class="swiper-slide"
                  v-for="(item, index) in productDetail.productImg"
                  :key="index"
                >
                  <div
                    :class="[index == curProductImg ? 'on' : '', 'detailImg']"
                    :data-index="index"
                    :data-img="item.img"
                    onClick="OnClickProductImg(this)"
                  >
                    <img :src="item.img" :alt="item.text" />
                  </div>
                </div>
              </swiperCpt>
              <div
                class="swiperBtn swiperBtn_left"
                @click="$refs.indexDetailimgSwiper.swiperSl.swipePrev()"
              ></div>
              <div
                class="swiperBtn swiperBtn_right"
                @click="$refs.indexDetailimgSwiper.swiperSl.swipeNext()"
              ></div>
            </div>
          </div>
          <div class="detailimg_cr">
            <img src="../assets/images/crile3.png" />
          </div>
        </div>
      </div>
      <div>
        <swiperCpt
          v-if="productDetail.productBgImgs.length > 0"
          class="productSwiperCpt wow fadeInUp animated"
          ref="indexproductSwiper"
          :slidesPerView="1"
          :delay="5000"
          :loop="productDetail.productBgImgs.length > 1?true:false"
          :autoplay="productDetail.productBgImgs.length > 1?true:false"
          sid="indexProductSwiper"
        >
          <div
            class="swiper-slide"
            v-for="(item, index) in productDetail.productBgImgs"
            :key="index"
          >
            <div class="productImg" v-for="(item2, index2) in item" :key="index2">
              <img :src="item2.img" :alt="item2.text" />
            </div>
          </div>
        </swiperCpt>
      </div>
      <div class="returnbtn" @click="goProduct">返回产品中心</div>
    </div>
  </div>
</template>
<script>
import Banner from "@/components/common/Banner.vue";
import recruitTit from "@/components/common/recruitTit";
import swiperCpt from "@/components/common/swiperCpt.vue";
import $ from "jquery.1";
export default {
  data() {
    return {
      curProductImg: 0,
      showProductImg: "", // 展示的产品主图
      resProducts: [],
      resBanners: [
        // {
        //   imageUrl: require("../assets/images/product/banner.png"),
        //   skipHref: "",
        // },
      ],
      dataList: [
        {
          id: 0,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/mainpro1.png"),
          text: "广达牌樟脑",
          brand: "广达牌",
          product: "樟脑",
          traits:
            "本品为白色结晶性粉末或无色半透明的硬块，有刺激性特臭，味初辛、后清凉；在常温中易升华，燃烧时发生黑烟及有光的火焰。本品在三氯甲烷中极易溶解，在乙醇、乙醚、脂肪油或挥发油中易溶，在水中极微溶解。",
          use: "主要用作医药原料，如皮肤刺激药和生产樟脑磺酸钠的主要原料。在塑料工业上主要作为制造赛璐珞等塑料的增塑制，在电子工业方面是某些材料的重要添加剂。国防上用作无烟炸药的爆炸隐定剂和减速剂；农业上用作杀虫剂等，如制衣服防蛀剂樟脑丸、球等；也可用作日常护理品和香精香料的原料。",
          qualityStandard:
            "符合中国药典(CP)、美国药典(USP)、日本药典(JP)、英国药典(BP)、德国药典(DAB)、欧盟药典(EP)等药用标准；符合国家标准GB/T4895。",
          package: "25Kg/箱。",
          productImg: [
            {
              img: require("../assets/images/product/shop7-7.png"),
              text: "樟脑7",
            },
            {
              img: require("../assets/images/product/shop7-8.png"),
              text: "樟脑8",
            },
            {
              img: require("../assets/images/product/shop7-9.png"),
              text: "樟脑9",
            },
            {
              img: require("../assets/images/product/shop7-1.png"),
              text: "樟脑1",
            },
            {
              img: require("../assets/images/product/shop7-2.png"),
              text: "樟脑2",
            },
            {
              img: require("../assets/images/product/shop7-3.png"),
              text: "樟脑3",
            },
            {
              img: require("../assets/images/product/shop7-4.png"),
              text: "樟脑4",
            },
            {
              img: require("../assets/images/product/shop7-5.png"),
              text: "樟脑5",
            },
            {
              img: require("../assets/images/product/shop7-6.png"),
              text: "樟脑6",
            },
          ],
          productBgImgs: [
            [
              {
                img: require("../assets/images/product/productBgImg20.png"),
                text: "樟脑3",
              },
              {
                img: require("../assets/images/product/productBgImg19.png"),
                text: "樟脑2",
              },
              {
                img: require("../assets/images/product/productBgImg18.png"),
                text: "樟脑1",
              },
              {
                img: require("../assets/images/product/productBgImg24.png"),
                text: "樟脑7",
              },
              {
                img: require("../assets/images/product/productBgImg23.png"),
                text: "樟脑6",
              },
              {
                img: require("../assets/images/product/productBgImg21.png"),
                text: "樟脑4",
              },
            ],
            [
              {
                img: require("../assets/images/product/productBgImg22.png"),
                text: "樟脑5",
              },
              {
                img: require("../assets/images/product/productBgImg25.png"),
                text: "樟脑8",
              },
              {
                img: require("../assets/images/product/productBgImg26.png"),
                text: "樟脑9",
              },
            ],
          ],
        },
        {
          id: 1,
          iconSrc: require("../assets/images/product/icon3.png"),
          img: require("../assets/images/product/mainpro2.png"),
          text: "白雪牌冰片",
          brand: "白雪牌",
          product: "冰片（合成龙脑）",
          traits:
            "本品为无色透明或半透明的片状松脆结晶；气清香，味辛、凉；具挥发性，点燃发生浓烟，并有带光的火焰。本品在乙醇、三氯甲烷或乙醚中易溶，在水中几乎不溶。",
          use: "冰片能开窍醒神，消热止痛。在中医药中用于治疗热病神昏、惊厥、中风痰厥、气郁暴厥、中恶昏迷、目赤、口疮、咽喉肿痛、耳道流脓等症状，冰片还是良好的食品、日常护理品和香精香料的原料。药品标准《中国药典》2015年版一部。 ",
          qualityStandard: "国药准字Z44023868",
          package: "25kg/桶。 1kg×10罐/箱。",
          productImg: [
            {
              img: require("../assets/images/product/shop1-4.png"),
              text: "冰片4",
            },
            {
              img: require("../assets/images/product/shop1-5.png"),
              text: "冰片5",
            },
            {
              img: require("../assets/images/product/shop1-6.png"),
              text: "冰片6",
            },
            {
              img: require("../assets/images/product/shop1-7.png"),
              text: "冰片7",
            },
            {
              img: require("../assets/images/product/shop1-1.png"),
              text: "冰片1",
            },
            {
              img: require("../assets/images/product/shop1-2.png"),
              text: "冰片2",
            },
            {
              img: require("../assets/images/product/shop1-3.png"),
              text: "冰片3",
            },
          ],
          productBgImgs: [
            [
              {
                img: require("../assets/images/product/productBgImg10.png"),
                text: "冰片10",
              },
              {
                img: require("../assets/images/product/productBgImg8.png"),
                text: "冰片8",
              },
              {
                img: require("../assets/images/product/productBgImg9.png"),
                text: "冰片9",
              },
              {
                img: require("../assets/images/product/productBgImg4.png"),
                text: "冰片4",
              },
              {
                img: require("../assets/images/product/productBgImg7.png"),
                text: "冰片7",
              },
              {
                img: require("../assets/images/product/productBgImg1.png"),
                text: "冰片1",
              },
            ],
            [
              {
                img: require("../assets/images/product/productBgImg6.png"),
                text: "冰片6",
              },
              {
                img: require("../assets/images/product/productBgImg2.png"),
                text: "冰片2",
              },
              {
                img: require("../assets/images/product/productBgImg5.png"),
                text: "冰片5",
              },
            ],
          ],
        },
        {
          id: 2,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop1.png"),
          text: "广达牌莰烯",
          brand: "广达牌",
          product: "莰烯",
          traits:
            "本品为无色或淡黄色透明晶体，溶于丙酮，微溶于乙醇，不溶于水。",
          use: "本品是合成樟脑的中间体，也可广泛用于合成香精香料。",
          qualityStandard: "符合企业标准 Q(HG)/HP 2.4。",
          package:
            "镀锌铁桶包装，根据客户要求，每桶净重170～175kg；或出口ISO-TANK装，净重约20t。",
          productImg: [
            {
              img: require("../assets/images/product/shop3-1.png"),
              text: "莰烯1",
            },
          ],
          productBgImgs: [],
        },
        {
          id: 3,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop2.png"),
          text: "广达牌双戊烯",
          brand: "广达牌",
          product: "双戊烯",
          traits:
            "无色或淡黄色液体，具有特殊气味，是消旋苧烯、异松油烯、α-松油烯等萜类化合物组成的混合物。溶于乙醇、乙醚、三氯甲烷等有机溶剂，与光或空气接触会变成黄色粘滞的液体。",
          use: "主要用于溶剂、扩散剂、金属清洗剂、也用于橡胶、油漆、油墨、地蜡等工业上；还可用于蚊虫驱避剂和紫苏醇的合成。本品也是橡胶再生溶剂和合成香料的基础原料。",
          qualityStandard: "符合企业标准 Q(HG)/HP101。",
          package:
            "镀锌铁桶包装，根据客户要求，每桶净重160～175kg；或出口ISO-TANK装，每罐净重约15～20t。",
          productImg: [
            {
              img: require("../assets/images/product/shop5-1.png"),
              text: "双戊烯1",
            },
          ],
          productBgImgs: [],
        },
        {
          id: 4,
          iconSrc: require("../assets/images/product/icon2.png"),
          img: require("../assets/images/product/shop3.png"),
          text: "三春牌醋酸钠",
          brand: "三春牌",
          product: "醋酸钠",
          traits:
            "本产品为无色或白色晶体，暴露于潮湿空气中易潮解，于干燥空气中易风化。易溶于水，稍溶于乙醇。在123℃时失去结晶水，变为无水醋酸钠。",
          use: "主要用于印染工业、医药、照相、电镀、化学试剂及有机合成的生产等。",
          qualityStandard: "符合企业标准 Q(HG)/HP104。",
          package: "聚丙烯编织袋内衬聚乙烯薄膜袋，25kg/袋。",
          productImg: [
            {
              img: require("../assets/images/product/shop2-1.png"),
              text: "醋酸钠1",
            },
            {
              img: require("../assets/images/product/shop2-2.png"),
              text: "醋酸钠2",
            },
          ],
          productBgImgs: [
            [
              {
                img: require("../assets/images/product/productBgImg13.png"),
                text: "醋酸钠3",
              },
              {
                img: require("../assets/images/product/productBgImg12.png"),
                text: "醋酸钠2",
              },
              {
                img: require("../assets/images/product/productBgImg14.png"),
                text: "醋酸钠4",
              },
              {
                img: require("../assets/images/product/productBgImg11.png"),
                text: "醋酸钠1",
              },
              {
                img: require("../assets/images/product/productBgImg27.png"),
                text: "醋酸钠5",
              },
            ],
          ],
        },
        {
          id: 5,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop4.png"),
          text: "广达牌乙酸异龙脑酯",
          brand: "广达牌",
          product: "乙酸异龙脑酯",
          traits: "本产品为微黄色或无色透明的油状液体，有芳香味，易挥发。",
          use: "本品是合成樟脑的中间体，同时又是一种实用价值很高的成品香料。",
          qualityStandard: "企业标准 Q(HG)/HP2.3。",
          package: "镀锌铁桶包装，每桶净重190kg；或出口ISO-TANK装，净重约20t。",
          productImg: [
            {
              img: require("../assets/images/product/shop6-1.png"),
              text: "乙酸异龙脑酯1",
            },
          ],
          productBgImgs: [],
        },
        {
          id: 6,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop5.png"),
          text: "广达牌蒎烯",
          brand: "广达牌",
          product: "蒎烯",
          traits:
            "本产品为无色透明液体，具有松萜特有气味，溶于乙醇、乙醚等，不溶于水。",
          use: "用于合成樟脑、冰片和合成香料的原料，也用于合成萜烯树脂和维生素E。",
          qualityStandard: "",
          package: "根据客户要求，采用160～175kg镀锌铁桶装或槽车装运。",
          productImg: [
            {
              img: require("../assets/images/product/shop4-1.png"),
              text: "蒎烯1",
            },
          ],
          productBgImgs: [],
        },
        {
          id: 7,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop6.png"),
          text: "广达牌异龙脑",
          brand: "广达牌",
          product: "异龙脑",
          traits:
            "本品为白色或微黄色结晶性粉末，在乙醇、氯仿或乙醚中易溶，在水中几乎不溶。",
          use: "主要用作医药防腐剂，制合成樟脑和香料等。",
          qualityStandard: "符合企业标准 Q(HG)/HP 2.5。",
          package: "25kg瓦楞纸箱包装，内衬聚乙烯薄膜袋。",
          productImg: [
            {
              img: require("../assets/images/product/shop6.png"),
              text: "异龙脑1",
            },
          ],
          productBgImgs: [
            [
              {
                img: require("../assets/images/product/productBgImg16.png"),
                text: "异龙脑2",
              },
              {
                img: require("../assets/images/product/productBgImg15.png"),
                text: "异龙脑1",
              },
              {
                img: require("../assets/images/product/productBgImg17.png"),
                text: "异龙脑3",
              },
            ],
          ],
        },
      ],
      productDetail: "",
    };
  },
  mounted() {
    this.getDataList();
    // console.log(this.$route.query);
    // 筛选当前详情内容
    let resProductDetail = this.dataList.filter((item, index) => {
      return Number(this.$route.query.id) === Number(item.id);
    });
    this.productDetail = resProductDetail[0];
    //暴露方法
    window.OnClickProductImg = this.OnClickProductImg;
  },
  methods: {
    // 点击产品
    OnClickProductImg(data) {
      console.log(data.getAttribute("data-index"));
      let index = $(data).data("index");
      let imgSrc = $(data).data("img");
      $(".detailimgSwiperCpt .detailImg").removeClass("on");
      $(data).addClass("on");
      this.curProductImg = index;
      this.showProductImg = imgSrc;
    },
    // 前往商品页
    goProduct() {
      this.$router.push("/product");
    },
    async getDataList() {
      let res = await this.$request.getImageAdvertisingList({
        advertisingPosition: "2",
      });
      if (res.code === 200) {
        this.resBanners = [];
        res.rows.map((item, index) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl;
        });
        this.resBanners = res.rows;
        this.$nextTick(() => {
          this.$refs.cBanner.reInitBanner();
        });
      }
    },
  },
  components: {
    Banner,
    recruitTit,
    swiperCpt,
  },
};
</script>
<style lang="scss">
.productDetail {
  .addrtit {
    font-size: 0.83vw;
    color: #666666;
    span {
      color: #83bb26;
    }
  }
  .maincon {
    margin-bottom: 3.13vw;
  }
  .detailcon {
    width: 43.49vw;
    min-height: 25.52vw;
    padding: 1.56vw;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0vw 0.1vw 0.42vw 0vw rgba(0, 0, 0, 0.08);
    margin-right: 2.6vw;
    .detailcon_tit {
      width: 11.51vw;
      height: 1.46vw;
      line-height: 1.46vw;
      margin-bottom: 1.04vw;
      text-align: center;
      color: #fff;
      font-size: 1.04vw;
      background-color: #87c31e;
    }
    .detailcon_main_tit {
      color: #87c31e;
      height: 0.78vw;
      line-height: 0.78vw;
      font-size: 0.83vw;
      padding-left: 0.52vw;
      margin-top: 1.04vw;
      border-left: 0.26vw solid #87c31e;
    }
    .detailcon_main_p {
      font-size: 0.83vw;
      color: #000000;
      line-height: 1.56vw;
      margin-top: 1.04vw;
    }
  }
  .detailimg {
    width: 26.82vw;
    height: 26.98vw;

    .detailimgcon {
      height: 26.98vw;
      text-align: center;
      overflow: hidden;
      vertical-align: middle;
      position: relative;
      z-index: 2;
      background-color: #ffffff;
      .showImgCon {
          width: 26.67vw;
          height: 20.52vw;
          border: solid 1px #f6f6f6;
          position: relative;
          img {
            width: 100%;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      .detailImgPagination {
        position: relative;
        .detailimgSwiperCpt {
          width: 22.29vw;
          margin: 1.56vw auto 0;
          position: relative;
          .detailImg {
            width: 3.44vw;
            height: 3.44vw;
            // background-color: #f3f3f1;
            border: solid 0.05vw #e0e0e0;
            position: relative;
            &.on {
              border: solid 0.05vw #87c31e;
            }
            margin: 0 auto 0;
            img {
              display: block;
              width: 100%;
              position: absolute;
              top: 50%;
              transform: translate(0, -50%);
            }
          }
        }
        .swiperBtn {
          width: 1.77vw;
          height: 1.77vw;
          cursor: pointer;
          position: absolute;
          top: 50%;
          margin-top: -0.89vw;
          z-index: 66;
          &.swiperBtn_left {
            left: 0;
            background: url("../assets/images/product/btn_left.png");
            background-size: cover;
            &:hover {
              background: url("../assets/images/product/btn_left_on.png");
              background-size: cover;
            }
          }
          &.swiperBtn_right {
            right: 0;
            background: url("../assets/images/product/btn_right.png");
            background-size: cover;
            &:hover {
              background: url("../assets/images/product/btn_right_on.png");
              background-size: cover;
            }
          }
        }
      }
    }
    .detailimg_cr {
      width: 7.29vw;
      position: relative;
      float: right;
      z-index: 1;
      margin-right: -3.65vw;
      margin-top: -3.65vw;
      img {
        width: 7.29vw;
      }
    }
  }
  .productSwiperCpt {
    .swiper-slide {
      .productImg {
          display: inline-block;
          width: 23.07vw;
          height: 14.48vw;
          margin: 0 0.52vw 0.52vw;
          overflow: hidden;
          position: relative;
          border: solid 1px #e0e0e0;
          img {
            display: block;
            width: 100%;
          }
        }
    }
  }
  .returnbtn {
    width: 10.42vw;
    height: 2.19vw;
    line-height: 2.19vw;
    text-align: center;
    color: #ffffff;
    font-size: 0.83vw;
    // margin-top: 1.04vw;
    margin: 2.6vw auto;
    cursor: pointer;
    background-color: #87c31e;
  }
}
@media (min-width: 1920px) {
  .productDetail {
    .addrtit {
      font-size: 16px;
      color: #666666;
      span {
        color: #83bb26;
      }
    }
    .maincon {
      margin-bottom: 60px;
    }
    .detailcon {
      width: 835px;
      min-height: 490px;
      padding: 30px;
      box-sizing: border-box;
      background-color: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      margin-right: 50px;
      .detailcon_tit {
        width: 221px;
        height: 28px;
        line-height: 28px;
        margin-bottom: 20px;
        text-align: center;
        color: #fff;
        font-size: 20px;
        background-color: #87c31e;
      }
      .detailcon_main_tit {
        color: #87c31e;
        height: 15px;
        line-height: 15px;
        font-size: 16px;
        padding-left: 10px;
        margin-top: 20px;
        border-left: 5px solid #87c31e;
      }
      .detailcon_main_p {
        font-size: 16px;
        color: #000000;
        line-height: 30px;
        margin-top: 20px;
      }
    }
    .detailimg {
      width: 515px;
      height: 518px;
      .detailimgcon {
        height: 518px;
        text-align: center;
        overflow: hidden;
        vertical-align: middle;
        position: relative;
        z-index: 2;
        background-color: #ffffff;
        .showImgCon {
          width: 512px;
          height: 394px;
          border: solid 1px #f6f6f6;
          position: relative;
          img {
            width: 100%;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .detailImgPagination {
          position: relative;
          .detailimgSwiperCpt {
            width: 428px;
            margin: 30px auto 0;
            position: relative;
            .detailImg {
              width: 66px;
              height: 66px;
              position: relative;
              // background-color: #f3f3f1;
              border: solid 1px #e0e0e0;
              &.on {
                border: solid 1px #87c31e;
              }
              margin: 0 auto 0;
              img {
                display: block;
                width: 100%;
                position: absolute;
                top: 50%;
                transform: translate(0, -50%);
              }
            }
          }
          .swiperBtn {
            width: 34px;
            height: 34px;
            cursor: pointer;
            position: absolute;
            top: 50%;
            margin-top: -17px;
            z-index: 66;
            &.swiperBtn_left {
              left: 0;
              background: url("../assets/images/product/btn_left.png");
              background-size: cover;
              &:hover {
                background: url("../assets/images/product/btn_left_on.png");
                background-size: cover;
              }
            }
            &.swiperBtn_right {
              right: 0;
              background: url("../assets/images/product/btn_right.png");
              background-size: cover;
              &:hover {
                background: url("../assets/images/product/btn_right_on.png");
                background-size: cover;
              }
            }
          }
        }
      }
      .detailimg_cr {
        width: 140px;
        position: relative;
        float: right;
        z-index: 1;
        margin-right: -70px;
        margin-top: -70px;
        img {
          width: 140px;
        }
      }
    }
    .productSwiperCpt {
      .swiper-slide {
        &::after,&::before{
          display: block;
          position: relative;
          clear: both;
          content: "";
        }
        .productImg {
          display: inline-block;
          width: 443px;
          height: 278px;
          margin: 0 10px 10px;
          overflow: hidden;
          position: relative;
          border: solid 1px #e0e0e0;
          img {
            display: block;
            width: 100%;
          }
        }
      }
    }
    .returnbtn {
      width: 200px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      color: #ffffff;
      font-size: 16px;
      // margin-top: 20px;
      margin: 50px auto;
      cursor: pointer;
      background-color: #87c31e;
    }
  }
}
</style>